import { DeleteHours, createBusinessHours, getCustomHours, updateBusinessHours } from "../../api/business_hours";

import { BUSINESS_HOURS } from "../../../constants/reducer_names";
import { FailedUserFetchResponse } from "../../../constants/error_messages";
import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  businessHoursList: [] as any,
  businessHoursListConstant: [] as any,
  loading: false,
  error: {
    hasError: false,
    errorMessage: "",
  },
  // businessHoursConstant: [] as any,
};

const businessHoursSlice = createSlice({
  name: BUSINESS_HOURS,
  initialState,
  reducers: {
    updateBusinessHours: (state, { payload }) => {
      // state.businessHoursList = [...[]]
      state.businessHoursList = payload.newValue;
      state.businessHoursListConstant = payload.newValue;
    },

    resetFilter: (state) => {
      state.businessHoursListConstant = [...state.businessHoursList];
    },

    filterdata: (state, { payload }) => {
      // state.businessHoursListConstant = []
      const searchTerm = payload?.toLowerCase();
      const filteredData = state.businessHoursList?.filter((result: any) => {
        let routingname = result?.name || "";
        return routingname?.toLowerCase().includes(searchTerm);
      });
      state.businessHoursListConstant = filteredData ?? state.businessHoursList;
    },

    deleteData: (state, { payload }) => {
      const index = state.businessHoursList.findIndex((element: any) => element.cid === payload?.id);
      const subIndex = state.businessHoursListConstant.findIndex((element: any) => element.cid === payload?.id);
      if (index !== -1 && subIndex !== -1) {
        state.businessHoursList.splice(index, 1);
        state.businessHoursListConstant.splice(subIndex, 1);
      }
    },

    reset: () => {},
  },
  extraReducers: (builder) => {
    builder.addCase(createBusinessHours.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createBusinessHours.fulfilled, (state, { payload }) => {
      if (payload?.response?.statuscode === 200) {
        state.error.hasError = false;
        state.error.errorMessage = "";
      } else {
        state.error.hasError = true;
        state.error.errorMessage = payload?.message ?? FailedUserFetchResponse;
      }
      state.loading = false;
    });
    builder.addCase(createBusinessHours.rejected, (state, { payload }: any) => {
      state.error.hasError = true;
      state.error.errorMessage = payload?.data?.message;
      state.loading = false;
    });

    builder.addCase(updateBusinessHours.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateBusinessHours.fulfilled, (state, { payload }) => {
      if (payload?.response?.statuscode === 200) {
        state.error.hasError = false;
        state.error.errorMessage = "";
      } else {
        state.error.hasError = true;
        state.error.errorMessage = payload?.message ?? FailedUserFetchResponse;
      }
      state.loading = false;
    });
    builder.addCase(updateBusinessHours.rejected, (state, { payload }: any) => {
      state.error.hasError = true;
      state.error.errorMessage = payload?.data?.message;
      state.loading = false;
    });

    builder.addCase(DeleteHours.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(DeleteHours.fulfilled, (state, { payload }) => {
      if (payload?.response?.statuscode === 200) {
        state.error.hasError = false;
        state.error.errorMessage = "";
      } else {
        state.error.hasError = true;
        state.error.errorMessage = payload?.message ?? FailedUserFetchResponse;
      }
      state.loading = false;
    });
    builder.addCase(DeleteHours.rejected, (state, { payload }: any) => {
      state.error.hasError = true;
      state.error.errorMessage = payload?.data?.message;
      state.loading = false;
    });

    // builder.addCase(getCustomHours.pending, (state) => {
    //     state.loading = true
    // })
    // builder.addCase(getCustomHours.fulfilled, (state, { payload }) => {
    //     if (payload?.response?.statuscode === 200) {
    //         state.businessHoursList = payload.data.getCustomHoursListList
    //         // state.error.hasError = false;
    //         // state.error.errorMessage = "";

    //     } else {
    //         state.error.hasError = true;
    //         state.error.errorMessage = payload?.message ?? FailedUserFetchResponse;

    //     }
    //     state.loading = false;

    // });
    // builder.addCase(getCustomHours.rejected, (state, { payload }: any) => {
    //     state.error.hasError = true;
    //     state.error.errorMessage = payload?.data?.message;
    //     state.loading = false;
    // });
  },
});

export const BusinessHoursActions = businessHoursSlice.actions;
export default businessHoursSlice.reducer;
